import * as z from "zod/v4";

export const bulkAdvancePlacing = {
  name: "bulkAdvancePlacing" as const,
  input: z.object({
    placements: z.array(
      z.object({
        workOrderId: z.string(),
        outputPlacements: z.array(
          z.object({
            productId: z.string(),
            storageLocationId: z.string(),
            quantity: z.number().int(),
          }),
        ),
      }),
    ),
  }),
  output: z.object({
    completedCount: z.number().int(),
    failedCount: z.number().int(),
  }),
};
